export const priceToInt = (price: string) => {
    const pseudo = document.createElement('div')
    pseudo.innerHTML = price
    const decoded = pseudo.innerText

    return parseInt(decoded.replace(/[^0-9]+/g, ''))
}
